import FavouriteButton from './FavouriteButton';
import FavouriteButtonContainer, { OwnProps } from './FavouriteButton.container';
export default FavouriteButtonContainer(FavouriteButton);
